import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import { cn } from '../../utils';
import { imageStyling } from './styling';
export const Image = ({ src, alt, className = '', fallbackIcon: FallbackIcon, size, rounding, }) => {
    const [hasError, setHasError] = useState(false);
    const FallbackIconComponent = FallbackIcon ? _jsx(FallbackIcon, { className: "text-gray-400 min-w-1/2 min-h-1/2 w-1/2 h-1/2" }) : null;
    if (!src || hasError) {
        return (_jsx("div", { className: cn(imageStyling({ size, rounding }), 'flex items-center justify-center bg-gray-100', className), children: FallbackIconComponent }));
    }
    return (_jsx("img", { src: src, alt: alt, className: cn(imageStyling({ size, rounding }), className), onError: () => setHasError(true) }));
};
